import { Zap, Wrench, Rocket } from 'lucide-react'

const StarEmoticon = ({ className }) => (
  <img src="/icons/star.png" alt="" className={`${className || ''} scale-125`} />
)

export const CATEGORY_CONFIG = {
  new_features: { label: 'New Features', icon: StarEmoticon, color: 'text-[var(--gold)]' },
  improvements: { label: 'Improvements', icon: Zap, color: 'text-blue-400' },
  bug_fixes: { label: 'Bug Fixes', icon: Wrench, color: 'text-green-400' },
  coming_soon: { label: 'Coming Soon', icon: Rocket, color: 'text-purple-400' },
}

export const CATEGORY_ORDER = ['new_features', 'improvements', 'bug_fixes', 'coming_soon']
